import { defineTranslateKeys } from 'lib/tolgee'
import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'

export const CUSTOM_DATE_PICKER_RANGE_I18N = defineTranslateKeys({
  triggerLabel: TOLGEE_GLOBALS.uploadDate,
})
